import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";

const NotFound: React.FC = () => {
  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-gradient-to-br from-gray-50 to-blue-50 text-center p-6">
      <motion.div
        initial={{ opacity: 0, scale: 0.8, rotate: -10 }}
        animate={{ opacity: 1, scale: 1, rotate: 0 }}
        transition={{
          type: "spring",
          stiffness: 150,
          damping: 15,
          duration: 0.7,
        }}
        className="flex flex-col items-center gap-6"
      >
        {/* Dental SVG - Inspired by your reference image */}
        <div className="w-48 h-48 relative">
          <svg
            viewBox="0 0 100 100"
            xmlns="http://www.w3.org/2000/svg"
            className="drop-shadow-lg"
          >
            {/* Tooth Body */}
            <path
              d="M30 20 C10 20 10 80 30 90 L70 90 C90 80 90 20 70 20 Z"
              fill="#FFFFFF"
              stroke="#A0D8FF" // Light blue border
              strokeWidth="2"
            />
            {/* Roots */}
            <path
              d="M35 90 C30 100 25 100 28 90 L32 90 C35 100 40 100 37 90 Z"
              fill="#FFFFFF"
              stroke="#A0D8FF"
              strokeWidth="2"
            />
            <path
              d="M65 90 C70 100 75 100 72 90 L68 90 C65 100 60 100 63 90 Z"
              fill="#FFFFFF"
              stroke="#A0D8FF"
              strokeWidth="2"
            />

            {/* Arms - one up, one down like in a sad posture */}
            <path
              d="M28 55 C20 50 15 60 20 65"
              fill="none"
              stroke="#555"
              strokeWidth="3"
              strokeLinecap="round"
            />
            <path
              d="M72 55 C80 50 85 60 80 65"
              fill="none"
              stroke="#555"
              strokeWidth="3"
              strokeLinecap="round"
            />

            {/* Sad Eyes */}
            <path
              d="M35 45 Q40 50 45 45"
              fill="none"
              stroke="#334155"
              strokeWidth="3"
              strokeLinecap="round"
            />
            <path
              d="M55 45 Q60 50 65 45"
              fill="none"
              stroke="#334155"
              strokeWidth="3"
              strokeLinecap="round"
            />

            {/* Sad Mouth */}
            <path
              d="M40 65 Q50 58 60 65"
              fill="none"
              stroke="#D32F2F" // Red for a sad mouth
              strokeWidth="3"
              strokeLinecap="round"
            />

            {/* 404 Text */}
            <text
              x="50"
              y="32"
              fontSize="14"
              fontWeight="bold"
              fill="#EF4444"
              textAnchor="middle"
              className="animate-bounce"
            >
              404
            </text>
          </svg>
        </div>

        {/* Text Content */}
        <div>
          <h1 className="text-4xl md:text-5xl font-extrabold text-blue-700">
            Oops! Missing Page.
          </h1>
          <p className="text-gray-600 mt-4 max-w-md">
            Looks like this page has a cavity and had to be extracted. Let's get
            you back to a healthy smile.
          </p>
        </div>

        {/* Action Button */}
        <Link
          to="/dashboard"
          className="mt-4 px-8 py-3 bg-blue-600 text-white font-semibold rounded-full hover:bg-blue-700 transition-all duration-300 shadow-xl hover:shadow-2xl transform hover:-translate-y-1"
        >
          Back to Dashboard
        </Link>
      </motion.div>
    </div>
  );
};

export default NotFound;